<template>
  <nav class="type-switcher">
    <router-link
      :to="$t('booking.link')"
      class="type-switcher__link"
    >
      <span class="type-switcher__inner">
        <icon
          type="qr"
          class="type-switcher__icon"
        />
        <span class="type-switcher__title">
          {{ $t('booking.title') }}
        </span>
      </span>
    </router-link>

    <router-link
      :to="$t('yullbe.link')"
      class="type-switcher__link"
    >
      <span class="type-switcher__inner">
        <icon
          type="yullbe"
          class="type-switcher__icon"
        />
        <span class="type-switcher__title">
          {{ $t('yullbe.title') }}
        </span>
      </span>
    </router-link>

    <router-link
      :to="$t('giftcards.link')"
      class="type-switcher__link"
    >
      <span class="type-switcher__inner">
        <icon
          type="gift"
          class="type-switcher__icon"
        />
        <span class="type-switcher__title">
          {{ $t('giftcards.title') }}
          <small class="type-switcher__subtitle">{{ $t('giftcards.subtitle') }}</small>
        </span>
      </span>
    </router-link>
  </nav>
</template>

<script>
import icon from './icon.vue'

export default {
  name: 'CTypeSwitcher',

  components: {
    icon
  }
}
</script>

<i18n locale="en">
{
  "booking": {
    "title": "Buy an E-Ticket",
    "link": "/booking"
  },
  "giftcards": {
    "title": "Gift Vouchers",
    "subtitle": "& Hardtickets",
    "link": "/giftcards"
  },
  "yullbe": {
    "title": "Buy YULLBE WUNDERLAND tickets",
    "link": "/yullbe"
  }
}
</i18n>

<i18n locale="de">
{
  "booking": {
    "title": "E-Ticket kaufen",
    "link": "/buchung"
  },
  "giftcards": {
    "title": "Geschenkgutscheine",
    "subtitle": "& Hardtickets",
    "link": "/gutscheine"
  },
  "yullbe": {
    "title": "YULLBE WUNDERLAND Tickets kaufen ",
    "link": "/yullbe"
  }
}
</i18n>

<style lang="scss">
@use "sass:math";
@import "../css/variables";

$breakpoint-type-switcher: $breakpoint-lg;

.type-switcher {
  position: relative;
  display: flex;
  justify-content: space-between;

  &::after {
    content: "";

    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 0.375em;

    background-image: linear-gradient(rgb(0 0 0 / 0), rgb(0 0 0 / 0.1) 70%, rgb(0 0 0 / 0.2));

    pointer-events: none;
  }
}

.type-switcher__link {
  flex-shrink: 1;
  display: inline-block;
  position: relative;
  padding: 0 $gutter-sm;

  text-decoration: none;
  color: $color-text;

  background-color: #fff;
  outline: none;

  &:hover,
  &:focus {
    color: #fff;
    background-color: $color-secondary;
  }

  &:first-child {
    margin-right: $gutter-xs;
  }

  &:last-child {
    margin-left: $gutter-xs;
  }

  &.is-active {
    flex-grow: 1;
    z-index: 1;
  }

  @media (min-width: $breakpoint-type-switcher) {
    width: 100% * math.div(1, 3);
    padding: 0 $gutter-md;

    &.is-active:first-child::after,
    &.is-active:last-child::before {
      content: "";

      position: absolute;
      top: 0;
      bottom: 0;
      width: 0.375em;

      pointer-events: none;
    }

    &.is-active:first-child::after {
      right: -0.375em;
      background-image: linear-gradient(to left, rgb(0 0 0 / 0), rgb(0 0 0 / 0.1) 70%, rgb(0 0 0 / 0.2));
    }

    &.is-active:last-child::before {
      left: -0.375em;
      background-image: linear-gradient(to right, rgb(0 0 0 / 0), rgb(0 0 0 / 0.1) 70%, rgb(0 0 0 / 0.2));
    }
  }
}

.type-switcher__inner {
  display: flex;
  align-items: center;
  height: 100%;
  padding: $gutter-sm 0;

  border-bottom: $border-dashed;
  border-bottom-color: transparent;

  .is-active & {
    border-bottom: $border-dashed;
  }

  .type-switcher__link:hover &,
  .type-switcher__link:focus & {
    border-bottom-color: transparent;
  }
}

.type-switcher__icon {
  flex-shrink: 0;

  font-size: 1.5em;
  color: $color-strong;

  .is-active & {
    color: $color-primary;
  }

  .type-switcher__link:hover &,
  .type-switcher__link:focus & {
    color: currentColor;
  }

  @media (min-width: $breakpoint-md) {
    font-size: 1.75em;
  }

  @media (min-width: $breakpoint-type-switcher) {
    font-size: 2.5em;
  }
}

.type-switcher__title {
  flex-shrink: 1;
  display: none;
  margin-left: $gutter-sm;

  font-weight: 650;
  line-height: 1.2;

  .is-active & {
    display: block;
  }

  @media (min-width: $breakpoint-md) {
    font-size: 1.1875em;
  }

  @media (min-width: $breakpoint-type-switcher) {
    display: block;
  }
}

.type-switcher__subtitle {
  display: block;
  margin-top: 0.25em;

  font-size: 0.85em;
  font-weight: 500;
  font-style: italic;
}
</style>
